<template>
  <CommonFramework :name="'找回密码'">
    <pop-panel :name="'手机验证'">
      <Input type="password" style="display:none;"/>
      <a-form
        :form="form"
        @submit="save"
        class="pop-common-form"
        :style="{width: '820px', margin: '0 auto'}">
        <a-form-item
          class="form-item"
          v-bind="formItemLayout"
          :validate-status="form.phone.validateStatus"
          :help="form.phone.help"
          hasFeedback>
          <template slot="label">
            <span class="required">手机号</span>
          </template>
          <Input
              placeholder="请输入手机号"
              v-model="form.phone.value"
              @change="validateHandler('phone', $event)" maxLength="11"/>
          <!-- <span class="iconTip" v-show="!form.phone.value"><img src="../../../assets/images/icon-tip.jpg">121313123</span> -->
  
        </a-form-item>
        <!-- <sendImg
          :value.sync="form.codeImg.value" 
          :validateStatus="form.codeImg.validateStatus"
          :help="form.codeImg.help"
          @checkCode="checkCodeImg"
        >
        </sendImg> -->
        <sendmobile 
          :phone = "form.phone.value"
          :value.sync="form.code.value" 
          :validateStatus="form.code.validateStatus"
          :help="form.code.help"
          :isSendCode.sync = isSendCode
          serviceType = 'PWD'
          @resetCode="getNewCode"
          @checkCode="checkCode"
        >
        </sendmobile>
        <a-form-item
          class="form-item"
          v-bind="formItemLayout"
          :validate-status="form.newPassword.validateStatus"
          :help="form.newPassword.help"
          hasFeedback>
          <template slot="label">
            <span class="required">新密码</span>
          </template>
          <Input
            type="password"
            placeholder="请输入密码"
            v-model="form.newPassword.value"
            @change="validateHandler('newPassword', $event)"
            maxLength="20"
          />
          <span class="iconTip" v-show="!form.newPassword.value && !form.newPassword.validateStatus"><img src="../../../assets/images/icon-tip.jpg"><span>{{this.pwdValidMsg}}</span></span>
        </a-form-item>
        <a-form-item
          class="form-item"
          v-bind="formItemLayout"
          :validate-status="form.confirmNewPassword.validateStatus"
          :help="form.confirmNewPassword.help"
          hasFeedback>
          <template slot="label">
            <span class="required">确认新密码</span>
          </template>
          <Input
            type="password"
            placeholder="请再次输入密码"
            v-model="form.confirmNewPassword.value"
            @change="validateHandler('confirmNewPassword', $event)"
            maxLength="20"
          />
          <span class="iconTip" v-show="!form.confirmNewPassword.value && !form.confirmNewPassword.validateStatus"><img src="../../../assets/images/icon-tip.jpg"><span>{{this.pwdValidMsg}}</span></span>
        </a-form-item>
        <a-form-item>
          <template>
            <span class="tip">选择其他方式认证：</span> 
            <a @click="jumpTolink('leyouauth-forget-email')" class="line">邮箱验证</a>
          </template>
        </a-form-item>
        <a-form-item
          class="form-item"
          label=" "
          v-bind="formItemLayout">
          <Button class="op-btn" type="primary" @click="save" :disabled="isDisabled">保存</Button>
          <Button class="op-btn" @click="jumpTolink('leyouforget')">返回</Button>
        </a-form-item>
      </a-form>
    </pop-panel>
  </CommonFramework>
  </template>
  
  <script>
    import CommonFramework from "../../../shared/components/lyCommonFramework/index";
    import { Input, Button } from 'ant-design-vue';
    import PopPanel from "@components/popPanel/index";
    import form from "../../../shared/utils/form";
    import sendmobile from '@components/sendsms/sendmobile/index';
    import appConst from '@utils/constant';
    import base64 from 'js-base64';
    import api from '@utils/api';
    import {$http, http, util} from '@utils';
    import queryString from 'query-string';
    import { setTimeout } from 'timers';
    import CONSTANT from '@utils/constant'
    // import sendImg from '@components/sendsms/sendImg/index';
  
    export default {
      name: "forget-mobile",
      components: {CommonFramework, PopPanel, Input, Button, sendmobile},
      mixins: [ form ],
      data () {
        return {
          pwdValidMsg: this.$store.state.securityConfig.pwdValidMsg,
          form: {
            phone: {
              value: '',
              validateStatus:'',
              help: ''
            },
            code: {
              value: '',
              validateStatus: '',
              help: ''
            },
            // codeImg: {
            //   value: '',
            //   validateStatus: '',
            //   help: '123'
            // },
            newPassword: {
              value: '',
              validateStatus: '',
              help: ''
            },
            confirmNewPassword: {
              value: '',
              validateStatus: '',
              help: ''
            },  
          },
          isSendCode: false,
          passwordShow: true,
        }
      },
      mounted() {
        util.$tracker(157, '288920',10000);
        // console.log(1111, this.form.newPassword.validateStatus)
      },
      watch: {
  
      },
      methods: {
        jumpTolink (name) {
          this.$router.push({
            name
          })
        },
        async getNewCode() {
          // this.validateFields(['newPhone'] 状态校验
          if (await this.validateFields(['phone'])) {
            this.isSendCode = true
          } else {
            this.isSendCode = false
          }
        },
        // checkCodeImg() {
        //   this.validateFields(['codeImg'])
        // },
        checkCode() {
          this.validateFields(['code'])
        },
        // 忘记密码-手机找回
        async forgetPwdByPhone(phone, pwd, confirmNewPassword, code) {
          const serviceCode = `${appConst.APPSERVICECODE_PWD}`;
          const _api = `${api.mainHost}/portal-api/account/forgetPwdByPhone.do`
          // const _api = `http://172.21.14.61/portal-api/account/forgetPwdByPhone.do`
          const param = JSON.stringify({
            phone: `${phone}`,
            password: `${pwd}`,
            confirmPassword: `${confirmNewPassword}`,
            verifyCode: `${code}`,
            serviceCode
          })
          const res = await http.post(_api, queryString.stringify({param}), {
            headers: {
              'content-Type': 'application/x-www-form-urlencoded'
            }
          })
          return res   
          },
        async save () {
          if (await this.validateFields()) {
            const res = await this.forgetPwdByPhone(this.form.phone.value, this.form.newPassword.value, this.form.confirmNewPassword.value, this.form.code.value)
            if (res.code * 1 === 1) {
              this.$message.success('密码找回成功');
              setTimeout(() => {
                this.jumpTolink('lylogin')
  
              }, 1000)
            } else {
              this.$message.error(res.msg || '系统异常');
            }
          }
  
        }
      }
    }
  </script>
  <style lang="scss" src="./index.scss" scoped></style>
  
  
  